import { render, staticRenderFns } from "./LyLuckDraw.vue?vue&type=template&id=60f35e00&scoped=true&"
import script from "./LyLuckDraw.vue?vue&type=script&lang=js&"
export * from "./LyLuckDraw.vue?vue&type=script&lang=js&"
import style0 from "./LyLuckDraw.vue?vue&type=style&index=0&id=60f35e00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f35e00",
  null
  
)

export default component.exports